import { render, staticRenderFns } from "./CreateParameterFromTemplate.vue?vue&type=template&id=21130b34"
import script from "./CreateParameterFromTemplate.vue?vue&type=script&lang=js"
export * from "./CreateParameterFromTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports